import { getToken } from "firebase/messaging";
import { messaging } from "./firebase";

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

const STORAGE_KEY = "beramour_fcm_token";

export async function registerForPush(force = false) {
  console.log("🚀 [PUSH] registerForPush CALLED");

  try {
    // 1. Check cached token
    const cached = localStorage.getItem(STORAGE_KEY);
    console.log("📦 [PUSH] Cached token:", cached);

    if (cached && !force) {
      console.log("✅ [PUSH] Using cached token");
      return cached;
    }

    // 2. Request permission
    console.log("🔔 [PUSH] Requesting notification permission...");
    const permission = await Notification.requestPermission();
    console.log("🔔 [PUSH] Permission result:", permission);

    if (permission !== "granted") {
      console.warn("⚠️ [PUSH] Permission not granted. Aborting.");
      return null;
    }

    // 3. Wait for service worker
    console.log("🛠️ [PUSH] Waiting for service worker...");
    const registration = await navigator.serviceWorker.ready;
    console.log("🛠️ [PUSH] Service worker ready:", registration);

    if (!registration) {
      console.error("❌ [PUSH] No service worker registration found");
      return null;
    }

    // 4. Generate token
    console.log("🔥 [PUSH] Calling getToken...");
    let token;

    try {
      token = await getToken(messaging, {
        vapidKey: VAPID_KEY,
        serviceWorkerRegistration: registration,
      });
    } catch (err) {
      console.error("❌ [PUSH] getToken threw error:", err);
      return null;
    }

    console.log("🔥 [PUSH] getToken result:", token);

    if (!token) {
      console.error("❌ [PUSH] getToken returned null/empty token");
      return null;
    }

    // 5. Cache token
    localStorage.setItem(STORAGE_KEY, token);
    console.log("💾 [PUSH] Token saved to localStorage");

    console.log("🎉 [PUSH] SUCCESS. FCM TOKEN:", token);
    return token;
  } catch (err) {
    console.error("💥 [PUSH] Unexpected failure:", err);
    return null;
  }
}

export function clearPushToken() {
  console.log("🧹 [PUSH] Clearing cached token");
  localStorage.removeItem(STORAGE_KEY);
}
